.c0{flex-shrink:0;}